import React from 'react';
import SEO from '../components/common/SEO';
import ProcessHero from '../components/process/ProcessHero';
import ProjectTimeline from '../components/process/ProjectTimeline';
import ProcessBottomBanner from '../components/process/ProcessBottomBanner';

const Process = () => {
  return (
    <>
      <SEO
        title="Our Process"
        description="From design selection to launch, see our step-by-step process for customizing your dream website seamlessly."
        keywords="website design process, web customization steps, how we work, web development workflow"
      />
      <ProcessHero />
      <ProjectTimeline />
      <ProcessBottomBanner />
    </>
  );
};

export default Process;